import * as Yup from 'yup'

export const emailSchema = () => {
  let emailSchema = Yup.object().shape({

    email_reason_note: Yup.string()
      .required('Required'),

    email_validate_by: Yup.string()
      .required('Required')

  })

  return emailSchema
}
export const isDeletedSchema = () => {
  let isDeletedSchema = Yup.object().shape({

    deleted_reason_note: Yup.string()
      .required('Required'),

    deleted_validate_by: Yup.string()
      .required('Required')

  })

  return isDeletedSchema
}

export const profileSchema = (isEditEmail,  isDeletedStasusEdit) => {
  let profileSchema = Yup.object().shape({
    name: Yup.string()
      .required('Required'),

    email: Yup.string().email()
      .required('Required'),

    mobile: Yup.string()
      .min(10, 'At least 10 digits')
      .matches(/^(^62)(\d{8,13})$/, 'Please input a valid mobile number, starting with 62')
      .required('Required'),

    gender: Yup.string()
      .required('Required'),

    birthday: Yup.date().nullable()
  })

  if (isEditEmail) {
    profileSchema = profileSchema.concat( emailSchema() )
  }

  if (isDeletedStasusEdit) {
    profileSchema = profileSchema.concat( isDeletedSchema() )
  }

  return profileSchema
}
